import { useSegments } from "api/segments";
import { useStyles } from "../ConditionReadOnly";

export const SegmentBox = ({
  id,
  "data-test-id": dataTestId,
}: {
  id: string;
  "data-test-id": string;
}) => {
  const classes = useStyles();
  const { useSegmentData } = useSegments();
  const { data: segmentData } = useSegmentData(id);

  return (
    <div className={classes.box} data-test-id={dataTestId}>
      {segmentData?.name || id}
    </div>
  );
};
